import { useUBL } from '@common/log-manager';
export const useCrossSellerProductUBL = () => {
  const sendUBL = useUBL();

  const impressCrossSellerProductUBL = () => {
    sendUBL({
      category: 'impression',
      navigation: 'product_detail',
      object_type: 'button',
      object_id: `cross_seller_item_list`,
    });
  };

  const clickCrossSellerProductUBL = () => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      object_type: 'button',
      object_id: `cross_seller_item_list`,
    });
  };

  const pageviewCrossSellerProductPageUBL = (is_opened: boolean) => {
    sendUBL({
      category: 'pageview',
      navigation: 'cross_seller_item_list',
      data: { is_opened },
    });
  };

  const impressCrossSellerProductCardUBL = (original_product_id: string, catalog_product_id: string, index: number) => {
    sendUBL({
      category: 'impression',
      navigation: 'cross_seller_item_list',
      object_type: 'catalog',
      object_id: catalog_product_id,
      object_idx: 0,
      data: { original_product_id, component_idx: 0, item_idx: index },
    });
  };

  const clickCrossSellerProductCardUBL = (original_product_id: string, catalog_product_id: string, index: number) => {
    sendUBL({
      category: 'click',
      navigation: 'cross_seller_item_list',
      object_type: 'catalog',
      object_id: catalog_product_id,
      object_idx: 0,
      data: { original_product_id, component_idx: 0, item_idx: index },
    });
  };

  return {
    impressCrossSellerProductUBL,
    clickCrossSellerProductUBL,
    pageviewCrossSellerProductPageUBL,
    impressCrossSellerProductCardUBL,
    clickCrossSellerProductCardUBL,
  };
};
